import { Queue } from '@rossum/api-client/queues';

// Queues without the `enabled` flag are treated as enabled.
export const isQueueEnabled = (queue: Pick<Queue, 'enabled'>) =>
  queue.enabled !== false;
